

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const Session = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inactivityTimeout = 1000 * 60 * 30;
  let timeoutId;
  const { token } = useSelector((state) => state.userState);


  return <div>{/* Render your data or other components here */}</div>;
}